export default 'leadsApp';
